import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.334 8a2 2 0 0 0 .52-1.333 2 2 0 0 0-2-2H9.401A2 2 0 0 0 7.52 2h-4a2 2 0 0 0-2 2 2 2 0 0 0 .52 1.333A2 2 0 0 0 2.04 8a2 2 0 0 0 0 2.667A2 2 0 0 0 1.52 12a2 2 0 0 0 2 2h9.333a2 2 0 0 0 1.48-3.333 2 2 0 0 0 0-2.667m-6.813 4.667h-4a.666.666 0 1 1 0-1.333h4a.667.667 0 1 1 0 1.333m0-2.667h-4a.667.667 0 1 1 0-1.333h4a.667.667 0 0 1 0 1.333m0-2.667h-4A.667.667 0 1 1 3.52 6h4a.667.667 0 0 1 0 1.333m0-2.666h-4a.667.667 0 0 1 0-1.334h4a.667.667 0 1 1 0 1.334m5.793 7.807a.62.62 0 0 1-.46.193H9.401c.16-.43.16-.903 0-1.333h3.453a.667.667 0 0 1 .667.666.67.67 0 0 1-.207.473m0-2.667a.62.62 0 0 1-.46.193H9.401c.16-.43.16-.903 0-1.333h3.453a.667.667 0 0 1 .667.666.67.67 0 0 1-.207.474m0-2.667a.62.62 0 0 1-.46.193H9.401c.16-.43.16-.903 0-1.333h3.453a.667.667 0 0 1 .667.667.67.67 0 0 1-.207.473"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })